<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconCopy_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M4 2h6a2 2 0 0 1 2 2v.75H6.75a2 2 0 0 0-2 2V12H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2"
        clip-rule="evenodd"
    />
    <rect width="8" height="8" x="6" y="6" fill="currentColor" rx="1.5" />
</svg>
